var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gx-floatpts",class:{ 'gx-floatpts--fixed': _vm.fixed }},_vm._l((_vm.pts),function(p,i){return _c('div',{key:i,staticClass:"gx-floatpts__dot",style:({
      left: p.left,
      bottom: 0,
      width: p.sz + 'px',
      height: p.sz + 'px',
      background: p.col,
      boxShadow: `0 0 6px ${p.col}`,
      animation: `gx-floatUp var(--gx-member-float-duration, ${p.dur}s) ${p.del}s infinite var(--gx-member-ease, ease-in)`
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }